import React, {useCallback, useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import getParamsFromString from "../../Utils/getParamsFromString";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../Utils/lib";
import {checkHidden} from "../../../../Utils/Form/FormDynamic/Utils/checkHidden";
import {useCurrentResolution} from "../../../../Hooks/useCurrentResolution";
import {useResponsiveStyles} from "../../../../Hooks/useResponsiveStyles";

const LabelScreenComponent = (props) => {
    const {
        element: {styles: sourceStyles, events, properties = {}},
        actionsContext, doActions, screenName
    } = props;
    const currentResolution = useCurrentResolution();
    const styles = useResponsiveStyles(sourceStyles, currentResolution);
    const globalScreenValues = useSelector(state => state.jsonScreen.globalValues);
    const list = useSelector(state => state.enqueryList);
    const userLanguage = useSelector(state => state.app.userLanguage);
    const [actions, setActions] = useState(null)
    const [label, setLabel] = useState('');
    const [customStyles, setCustomStyles] = useState({});

    const isHidden = useMemo(() => {
        return checkHidden({...globalScreenValues, ...actionsContext}, properties.hideCondition, screenName);
    }, [JSON.stringify(globalScreenValues), JSON.stringify(actionsContext), properties.hideCondition, screenName])

    useEffect(() => {
        getLabel({list, ...globalScreenValues}, actionsContext);
        if (events && events[0].event === 'onClick') {
            setActions(events[0].actions)
        }
    }, []);

    useEffect(() => {
        getLabel({list, ...globalScreenValues}, actionsContext);
    }, [JSON.stringify(globalScreenValues), JSON.stringify(list), JSON.stringify(actionsContext), userLanguage]);

    const onClick = useCallback((e) => {
        if (actions) {
            e.stopPropagation();
            doActions(actions, actionsContext);
        }
    }, [])

    if (properties && properties.hidden) return <></>;

    function getStyles() {
        const onLoad = (events || []).find(e => e.event === 'onLoad');
        if (onLoad) {
            const actions = onLoad.actions;
            const setStyles = (actions || []).find(e => e.type === 'setStyles');
            if (setStyles) {
                return getParamsFromString(setStyles.value, {...globalScreenValues, ...actionsContext}, screenName);
            }
        }
    }

    function getLabel(globalValues, actionsContext) {
        const multiLanguageLabel = multiLanguageValue(properties.label, userLanguage);
        let label = getParamsFromString(multiLanguageLabel, {...actionsContext, ...globalValues}, screenName, {}, false, globalValues?._preScript);
        const styles = getStyles();
        setCustomStyles(styles || {});
        setLabel(typeof label === 'object' ? '' : label)
    }



    const wrapperStyles = {
        width: styles.width,
        textAlign: styles.textAlign,
        padding: styles.padding,
        margin: styles.margin,
        background: styles.background,
        height: styles.height,
        border: '1px solid transparent',
        display: isHidden ? 'none' : 'block',
        whiteSpace: styles.whiteSpace,
        ...customStyles
    };
    const labelStyles = {
        fontSize: styles.fontSize,
        fontWeight: styles.fontWeight,
        fontStyle: styles.fontStyle,
        textDecoration: styles.textDecoration,
        color: styles.color,
        cursor: actions ? 'pointer' : '',
    }

    return (
        <div style={wrapperStyles} className={styles.className}>
                <span
                    style={labelStyles}
                    onClick={onClick}
                >
                    {label}
                </span>
        </div>
    )
};
export default JsonScreenHoc(LabelScreenComponent);

LabelScreenComponent.propTypes = {
    element: PropTypes.object,
    actionsContext: PropTypes.object,
    screenName: PropTypes.string,
    globalValues: PropTypes.object
};
LabelScreenComponent.defaultProps = {
    actionsContext: {}
};